import theme from 'src/theme';
import { PageType } from 'src/types/Page';
import { NoonReportStatusEnum, NoonReportTypeEnum } from 'src/types/ViewModel/AolEnums';
import styled from 'styled-components';

export const BunkeringSidePanelWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    .aol-list-header {
        font-size: 0.8rem;
        font-weight: 500;
        background: ${theme.legacyColors.headingPanelBgColor};
        padding: 0;
        color: ${theme.legacyColors.headingColor};
        border-bottom: 2px solid ${theme.legacyColors.headingColor};
        height: 60px;

        &.filter-header {
            padding: 0;
        }

        &.button-header {
            padding: 0;
        }
    }
`;

export const AolFilterWrapper = styled.div`
    flex: 0 0 auto;
`;

export const BunkeringDateListWrapper = styled.div`
    flex: 1;
    overflow-y: auto;
`;

export const BunkeringListItemWrapper = styled.div`
    margin-top: 2px;
`;

type StyledProps = {
    isSelected?: boolean;
    noonReportType?: NoonReportTypeEnum;
    noonReportStatus?: NoonReportStatusEnum;
    isValid?: boolean;
    page?: PageType;
};

export const BunkeringListItem = styled.div<StyledProps>`
    box-shadow: 0 5px 5px -3px #ddd;
    border-bottom: 1px solid #ddd;
    padding: 4px;
    cursor: pointer;
    color: #04265a;
    font-weight: 500;
    font-size: 0.9rem;
    ${(props) => props.theme.selectableElement(props.isSelected)}
    ${(props) => props.theme.noonReportTypeListMarker(props.noonReportType, props.isValid)}
    position: relative;
    display: flex;
    justify-content: space-between;
    min-height: 40px;
    > span {
        align-content: center;
    }
`;
